import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { LinqCanvasModule } from '../canvas/linq.canvas.module';
import { UIComponentsModule } from '../ui-components/ui-components.module';
import { FormsModule } from '@angular/forms';
import { NodePropertiesComponent } from './nodes/node-properties.component';
import { NodeDialogComponent } from './nodes/node-dialog.component';
import { FrequencyDialogComponent } from './tempo-dialog/frequency-dialog.component';
import { EdgePropertiesComponent } from './edges/edge-properties.component';
import { FilterComponent } from './filter/filter.component';
import { GroupPropertiesComponent } from './group/group-properties.component';
import { CarbonEmissionsDialogComponent } from './carbon/carbon-emissions-dialog.component';
import { InformationAssetDialogComponent } from './information-asset/information-asset-dialog.component';
import { TagsListComponent } from './palette-bar/tags-list.component';
import { PaletteBarComponent } from './palette-bar/palette-bar.component';
import { ResizeObserverDirective } from '../resize-observer.directive';
import { InsightsModule } from '../insights/insights.module';
import { SelectNodeDialogComponent } from './nodes/select-node-dialog.component';
import { SelectNodeComponent } from './nodes/select-node.component';

@NgModule({
  declarations: [
    SelectNodeComponent,
    NodePropertiesComponent,
    NodeDialogComponent,
    SelectNodeDialogComponent,
    FrequencyDialogComponent,
    EdgePropertiesComponent,
    FilterComponent,
    GroupPropertiesComponent,
    CarbonEmissionsDialogComponent,
    InformationAssetDialogComponent,
    PaletteBarComponent,
    TagsListComponent
  ],
  exports: [
    NodePropertiesComponent,
    SelectNodeDialogComponent,
    EdgePropertiesComponent,
    GroupPropertiesComponent,
    InformationAssetDialogComponent,
    PaletteBarComponent,
    TagsListComponent,
    SelectNodeComponent
  ],
  imports: [
    MaterialModule,
    UIComponentsModule,
    LinqCanvasModule,
    FormsModule,
    ResizeObserverDirective,
    InsightsModule
  ],
  providers: [
  ]
})
export class ModelComponentsModule { }

